<template>
  <div>
    <div class="fullwidth small-bottom-padding narex" :class="videoUrl ? '': 'noBottom'">
      <div class="flex-start">
        <h1>{{ gallery.name }}</h1>
        <search-widget right />
      </div>
       <div class="button-groups">
        <animation-style-button-group :value="gallery" />
        <div>
          <ix-router-link class="button green" to="/animation-commissioning">{{ $nippets.ourGuide}}</ix-router-link>
        </div>
      </div>
      <div class="video-panel-wide" v-if="videoUrl">
        <page-video-player :url="videoUrl" :artistLinks="videoData" autoplay loop />
      </div>
    </div>
    <transition name="fade">
        <div class="fullwidth no-top-padding narex" v-show="loaded">
          <style-animation-grid :galleryData="galleryData" />
          <div class="a-right">
            <top-button />
          </div>
        </div>
      </transition>
  </div>
     
</template>

<script>
import SearchWidget from '@/components/widgets/SearchWidget.vue'
import TopButton from '@/components/buttons/TopButton.vue'
import PageVideoPlayer from '@/components/video/PageVideoPlayer.vue'
import StyleAnimationGrid from '@/components/panels/StyleAnimationGrid.vue'
import AnimationStyleButtonGroup from '@/components/panels/AnimationStyleButtonGroup.vue'
import videoStyleGalleries from '@/data/video-timings.js'
import MetatagPage from '@/mixins/MetatagPage.js'

export default {
  mixins: [MetatagPage],
  components: {
    SearchWidget,
    TopButton,
    PageVideoPlayer,
    StyleAnimationGrid,
    AnimationStyleButtonGroup
  },
  props: {
    url: String
  },
  data () {
    return {
      gallery: { gallery_id: '0'},
      galleryData: [],
      mode: 'az',
      location: 'ZZ',
      loaded: false,
      videoData: [],
      videoUrl: null
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData(){
      this.loaded = false
      await this.$store.dispatch('fetchArtists')
      this.gallery = await this.$store.dispatch('fetchGallery', '/styles/animation/' + this.url)
      let vd = videoStyleGalleries[this.gallery.url]
      if(vd) {
        this.videoData = vd.timings
        this.videoUrl = 'mediastore/video' + this.gallery.url + '.mp4'
      }
      else {
        this.videoUrl = null
      }
      let gd = await this.$store.dispatch('fetchGalleryData', this.gallery.gallery_id)
    
      let artists = this.$store.getters.nonExcludedArtists.filter(el => el.artist_id)
      let lang = this.$store.state.lang.toLowerCase()
      if(this.location !== 'ZZ'){
        artists = artists.filter(el => el.region === this.location)
      }
      else {
        artists = artists.filter(el => { return (el.region !== 'DE' || el.show_on_all) })
        artists = artists.filter(el => { return  !el.hiddens.includes(lang) })
      }
      gd = gd.filter(el => artists.find(al => al.artist_id === el.artist_id))
      this.sortArtists(gd)
      this.galleryData = gd
      
      this.loaded = true
    },
    sortArtists: function (res) {
      if(this.mode === 'random'){
        res.sort((el, el1) => { return el.rnd - el1.rnd })
      }
      else if(this.mode === 'az') {
        res.sort((el, el1) => { return el.name.localeCompare(el1.name) })
      }
    }
  },
  watch: {
    '$route.path': function () {
      this.loadData()
    }
  }
}
</script>
<style scoped>
.flex-start h1{
  margin-bottom:20px;
}

.button-groups{
  display:flex;
  justify-content: space-between;
  align-items:flex-start;
}



@media screen and (max-width:768px){
  .search-holder{
    display:none;
  }
}
</style>
